import { useEffect, useState } from "react";
import { scrollToId } from "../lib/smooth";

/* Sticky in-page navigation. Laptop: a row of pills with the label on the left.
   Phone: a swipeable chip strip so every section stays one tap away. */
export const SubNav = ({ items, label }) => {
  const [active, setActive] = useState(items[0][0]);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) setActive(e.target.id); }),
      { rootMargin: "-45% 0px -50% 0px" },
    );
    items.forEach(([id]) => { const el = document.getElementById(id); if (el) obs.observe(el); });
    return () => obs.disconnect();
  }, [items]);

  const go = (e, id) => {
    e.preventDefault();
    window.history.replaceState(null, "", `#${id}`);
    scrollToId(id);
  };

  return (
    <nav className="sticky top-[72px] z-40 border-b border-ink/10 bg-white/95 backdrop-blur" aria-label={label} data-testid="programmes-subnav">
      <div className="mx-auto flex max-w-7xl items-center gap-6 px-5 sm:px-8">
        <span className="hidden shrink-0 font-display text-xs font-bold uppercase tracking-[0.2em] text-night/70 lg:block">{label}</span>
        <ul className="-mx-5 flex snap-x gap-2 overflow-x-auto px-5 py-3 [scrollbar-width:none] sm:mx-0 sm:px-0 lg:flex-wrap lg:overflow-visible">
          {items.map(([id, name]) => (
            <li key={id} className="snap-start">
              <a href={`#${id}`} onClick={(e) => go(e, id)} data-testid={`subnav-link-${id}`} aria-current={active === id ? "true" : undefined}
                className={`block whitespace-nowrap rounded-full px-4 py-2 font-display text-sm font-bold transition-colors ${active === id ? "bg-ink text-white" : "bg-sky text-ink hover:bg-sun/40"}`}>
                {name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};
